import { Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import Widget from "./Widget";
import {
  AddShoppingCartRounded,
  IndeterminateCheckBoxOutlined,
  KeyboardReturnRounded,
  ShoppingBagOutlined,
} from "@mui/icons-material";
import { action, API, controller } from "../../api/api";
import { ToFormData } from "../../hooks/Method";

const FinancialTotals = ({ sortDate }) => {
  const [value, setValue] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sortDate.fromDate && sortDate.toDate) {
      setLoading(true);
      API(controller.HomeReport + action.FinancialTotals).post(
        ToFormData({
          fromDate: new Date(sortDate.fromDate).toISOString(),
          toDate: new Date(sortDate.toDate).toISOString(),
        }),
        (res) => {
          res && res.status === 200 && setValue({ ...res.result });
          setLoading(false);
        }
      );
    }
    return () => {};
  }, [sortDate]);

  return !loading ? (
    <Grid container spacing={3} className="uppercase">
      <Grid item xs={12} md={6} lg={3}>
        <Widget
          title="total sale"
          value={value.totalSale}
          icon={<ShoppingBagOutlined className="text-[35px]" />}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <Widget
          title="purchases"
          value={value.totalPurchase}
          icon={<AddShoppingCartRounded className="text-[35px]" />}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <Widget
          title="sales return"
          value={value.totalReturn}
          icon={<KeyboardReturnRounded className="text-[35px]" />}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <Widget
          title="total expenses"
          number="$0.00"
          icon={<IndeterminateCheckBoxOutlined className="text-[35px]" />}
        />
      </Grid>
    </Grid>
  ) : (
    "Loading..."
  );
};

export default FinancialTotals;
